import * as z from 'zod';

export const magazineQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type MagazineQueryLinkerSchema = z.infer<typeof magazineQueryLinkerSchema>;
